export enum PaymentProcessingType {
    BUILDING = "BUILDING",
    STORE_PACKAGE = "STORE PACKAGE"
}